export default __webpack_public_path__ + "static/media/image-ph-study-main-2-n-w.ec5ef596.webp";